<div
  class="b-tag"
  [class]="styleClass"
  [ngStyle]="{ 'background-color': getThemeColors().backgroundColor }"
>
  <div
    *ngIf="icon && iconPosition != 'right'"
    class="b-tag-icon b-tag-icon-left"
    [class]="icon"
    [ngStyle]="{ color: getThemeColors().iconColor }"
  ></div>
  <div class="b-tag-value" [ngStyle]="{ color: getThemeColors().textColor }">
    {{ value }}
  </div>
  <div
    *ngIf="icon && iconPosition === 'right'"
    class="b-tag-icon b-tag-icon-right"
    [class]="icon"
    [ngStyle]="{ color: getThemeColors().iconColor }"
  ></div>
</div>
